import axios from '../axios'

const putAnnouncementApi = async (announcementId, payload) => {
  return await axios.put(`api/lms/announcements/${announcementId}`, payload)
}

export default putAnnouncementApi
